import { useLocale } from '@adsk/alloy-react-helpers';

const useTranslateDefaultOptions = () => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const DEFAULT_OPTION_COMPANIES = {
    id: 'UNSELECTED_OPTION',
    name: T.translate('VALUE_FROM_ACCOUNT_ADMIN'),
    status: '',
    description: T.translate('DEFAULT_OPTION_COMPANY_DESCRIPTION'),
  };

  const DEFAULT_OPTION_ROLES = {
    id: 'UNSELECTED_OPTION',
    name: T.translate('VALUE_FROM_ACCOUNT_ADMIN'),
    status: '',
    description: T.translate('DEFAULT_OPTION_ROL_DESCRIPTION'),
  };

  return {
    DEFAULT_OPTION_COMPANIES,
    DEFAULT_OPTION_ROLES,
  };
};

export default useTranslateDefaultOptions;
